'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var cookieHelper = _interopDefault(require('../helpers/cookie-helper.js'));
var utils_js = require('../helpers/utils.js');

/**
 * Javascript component to help you set announcement banners.
 * @param {$DOM} el Element
 * @param {Object} [options] configuration options
 * @param {String} [options.announcementId=$el.data('announcementId')] a unique id to represent the announcement cookie
 * @param {String} [options.cookieDuration=604800000] duration that cookie will last (in milliseconds)
 * @param {String} [options.closeTarget='.js-announcement__close'] the target class to trigger the announcement to close
 * @param {String} [options.activeClass='is-active'] the class to toggle the announcement between active and inactive with
 * @class Announcement
 * @constructor
 */
function Announcement(el, options) {
  this.$el = utils_js.isJquery(el) ? el : $(el);
  this.$container = this.$el.parent();

  this.settings = _Object$assign({
    announcementId: this.$el.data('announcementId'),
    // 1 week (milli * sec * min * hour * day)
    cookieDuration: 1000 * 60 * 60 * 24 * 7,
    closeTarget: '.js-announcement__close',
    activeClass: 'is-active'
  }, options);

  this.cookieKey = 'announcement_closed_' + this.settings.announcementId;

  if (!cookieHelper.get(this.cookieKey)) {
    this.open();
  }

  this.$el.on('click', this.settings.closeTarget, this.close.bind(this));
}

/**
 * Opens the announcement banner
 * @method open
 */
Announcement.prototype.open = function () {
  this.$el.addClass(this.settings.activeClass);
};

/**
 * Closes the announcement banner
 * @method close
 */
Announcement.prototype.close = function () {
  this._setCookie();
  this.$el.removeClass(this.settings.activeClass);
  this.$container.focus();
};

Announcement.prototype._setCookie = function () {
  var date = new Date();
  var expTime = date.getTime() + this.settings.cookieDuration;
  date.setTime(expTime);

  cookieHelper.set(this.cookieKey, true, {
    expires: date.toGMTString()
  });
};

module.exports = Announcement;
